import IMG_LOAD from '../assets/img/Infinity-1s-200px.gif';
import API from './API.js';
import ERROR_CODE from './errorCode';
import Strings from './strings';

const ROLE = {
	ADMIN: 'Z',
	MANUFACTURER: 'M',
	AUTHORITY: 'A',
};

const Language = {
	English: 'English',
	Vietnamese: 'Tiếng Việt',
};
  
const LanguageCode = {
	English: 'en',
	Vietnam: 'vi-VN',
};

const COLORS = {
	BG_GREEN: '#e2ffdafe',
	GRAY: '#8a8a8a',
	BLACK: '#000000',
	RED: '#ff3333',
	GREEN_SOFT: '#e2ffdb',
	RED_SOFT: '#ffd9da',
	GREEN: '#4ca750',
}

const FONTS = {
	PRIMARY: "Nunito",
}

const FONT_SIZES = {
	SMALL: '14px',
	NORMAL: '16px',
	LARGE: '18px',
	BIG:'30px',
}


export {
	ROLE,
	COLORS,
	FONTS,
	Strings,
	Language,
	LanguageCode,
	FONT_SIZES,
	IMG_LOAD,
	API,
	ERROR_CODE,
}

export default {
	ROLE,
	COLORS,
	FONTS,
	FONT_SIZES,
	Strings,
	Language,
	LanguageCode,
	IMG_LOAD,
	API,
	ERROR_CODE,
}